import { cache } from 'react';

export const cachedFetch = cache(async function (
  request: Request
): Promise<Response> {
  const response = await fetch(request);
  return response.clone();
});
